const CHUNK_ERROR_MESSAGES = [
  "failed to fetch dynamically imported module",
  "importing a module script failed",
  "error loading dynamically imported module",
  "loading chunk",
  "chunkloaderror",
  "not a valid javascript mime type",
  "text/html",
];

const LOCATION_EVALUATION_REGEX = /undefined is not an object \(evaluating '.*\.location'\)/i;

export const isLikelyChunkError = (message: string) => {
  const lowerMessage = message.toLowerCase();
  return (
    CHUNK_ERROR_MESSAGES.some((snippet) => lowerMessage.includes(snippet)) ||
    LOCATION_EVALUATION_REGEX.test(message)
  );
};
